(function () {
  'use strict';

  var root = document.getElementById('bb-lp');
  if (!root) return;

  /* ---------- Config ---------- */
  var ext = window.BB_SHOPIFY || {};
  var CONFIG = {
    currency: ext.currency || 'USD',
    prices: {
      subscribe: Object.assign({ 1: 22.49, 2: 44.98, 3: 67.47 }, ext.prices && ext.prices.subscribe),
      oneTime: Object.assign({ 1: 24.99, 2: 45.00, 3: 63.75 }, ext.prices && ext.prices.oneTime)
    },
    variants: Object.assign({ lemon: null, berry: null, tropical: null, pm: null, cm: null, variety: null }, ext.variants),
    sellingPlans: Object.assign({ 21: null, 42: null }, ext.sellingPlans),
    afterAdd: ext.afterAdd === 'cart' ? 'cart' : 'checkout'
  };
  var SUB = CONFIG.prices.subscribe;
  var ONE = CONFIG.prices.oneTime;
  var STICKS_PER_BAG = 20;

  var assets = {};
  try { assets = JSON.parse(document.getElementById('bb-assets').textContent); } catch (e) { /* keep defaults */ }

  var FLAVORS = {
    variety: { name: 'Variety Pack', note: 'Berry, Tropical, Peach Mango and Mocha in one bag. Can’t decide? Don’t.' },
    lemon: { name: 'Lemon Drop', note: 'Sweet-tart citrus, bright as July. New ultra-fast dissolving formula.' },
    berry: { name: 'Mixed Berry', note: 'Juicy, classic berry. The one your friends will steal.' },
    tropical: { name: 'Tropical', note: 'Sun-warm island fruit. A two-minute vacation.' },
    pm: { name: 'Peach Mango', note: 'Tangy peach, ripe mango. For sour-candy people.' },
    cm: { name: 'Coffee Mocha', note: 'The coffee-shop flavor, without the coffee-shop line.' }
  };

  /* ---------- Helpers ---------- */
  function qa(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function q(sel) { return root.querySelector(sel); }
  function set(name, text) { qa('[data-bind="' + name + '"]').forEach(function (el) { el.textContent = text; }); }
  function setHidden(el, on) { if (on) el.setAttribute('hidden', ''); else el.removeAttribute('hidden'); } // works for SVG too
  function money(n) { return '$' + n.toFixed(2); }
  function perStick(price, bags) {
    var cents = Math.round((price / (STICKS_PER_BAG * bags)) * 100);
    return cents >= 100 ? '$' + (cents / 100).toFixed(2) : cents + '¢';
  }
  var reduceMotion = false;
  try { reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* ignore */ }

  /* ---------- State ---------- */
  var state = { flavor: 'variety', bags: 2, sub: true, every: 21, busy: false, added: false, error: '' };
  function price() { return state.sub ? SUB[state.bags] : ONE[state.bags]; }

  function render() {
    var s = state;
    var f = FLAVORS[s.flavor];
    var p = price();

    var g = q('[data-gallery]');
    if (assets[s.flavor] && g.getAttribute('src') !== assets[s.flavor]) g.src = assets[s.flavor];
    g.alt = 'Buzz Bomb ' + f.name + ' pouch';
    set('flavorName', f.name);
    set('flavorNote', f.note);
    qa('[data-flavor]').forEach(function (b) { b.setAttribute('aria-pressed', String(b.getAttribute('data-flavor') === s.flavor)); });

    qa('[data-bags]').forEach(function (b) {
      var n = Number(b.getAttribute('data-bags'));
      var tp = s.sub ? SUB[n] : ONE[n];
      b.setAttribute('aria-pressed', String(n === s.bags));
      b.querySelector('[data-tier="price"]').textContent = money(tp);
      b.querySelector('[data-tier="per"]').textContent = perStick(tp, n) + ' a stick';
    });
    // "Best value" is only true with the subscription's volume pricing.
    qa('[data-sub-only]').forEach(function (el) { setHidden(el, !s.sub); });

    set('subPrice', money(SUB[s.bags]));
    set('subCompare', money(24.99 * s.bags));
    set('onePrice', money(ONE[s.bags]));
    set('oneMeta', 'Shipping and taxes calculated at checkout');
    qa('input[name="bb-purchase"]').forEach(function (r) { r.checked = (r.value === 'sub') === s.sub; });
    var sel = q('[data-every]');
    if (sel && Number(sel.value) !== s.every) sel.value = String(s.every);

    var cta = q('[data-action="cta"].bb-cta');
    qa('[data-action="cta"]').forEach(function (b) { b.disabled = s.busy; });
    cta.classList.toggle('is-added', s.added);
    set('ctaTxt', s.busy ? 'Adding…' : s.added ? 'Added to cart' : 'Add to cart · ' + money(p));
    set('fine', s.sub ? 'Renews every ' + (s.every / 7) + ' weeks at ' + money(p) + ' plus shipping and taxes until canceled.' : 'One-time purchase. No subscription.');
    var err = q('[data-bind="ctaError"]');
    err.hidden = !s.error;
    err.textContent = s.error;

    var sticky = q('[data-mbar] [data-action="cta"]'); if (sticky) sticky.textContent = s.busy ? 'Adding…' : 'Add · ' + money(p);
    set('barLine', f.name + ' · ' + s.bags + (s.bags === 1 ? ' bag' : ' bags'));
    set('barSub', money(p) + (s.sub ? ' every ' + (s.every / 7) + ' weeks' : ' one-time'));

    // Pace cards ("How much buzz do you need?"): prices come from the same table.
    qa('[data-pace]').forEach(function (b) {
      var pace = b.getAttribute('data-pace').split('-');
      var n = Number(pace[0]);
      var every = Number(pace[1]);
      var on = s.sub && s.bags === n && s.every === every;
      b.setAttribute('aria-pressed', String(on));
      b.textContent = on ? 'Selected ✓' : 'Choose plan';
      var card = b.closest('.bb-pace-card');
      if (!card) return;
      var pp = function (k, text) { var el = card.querySelector('[data-pp="' + k + '"]'); if (el) el.textContent = text; };
      pp('price', money(SUB[n]));
      pp('was', money(24.99 * n));
      pp('per', perStick(SUB[n], n) + ' a stick');
    });
  }

  function scrollToBuy() {
    var card = q('[data-buy-form]');
    if (card && card.scrollIntoView) card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
  }

  /* ---------- Cart ---------- */
  function track(value) {
    var detail = { value: value, currency: CONFIG.currency, flavor: state.flavor, bags: state.bags, subscribe: state.sub, every: state.sub ? state.every : null };
    try { root.dispatchEvent(new CustomEvent('bb:add-to-cart', { bubbles: true, detail: detail })); } catch (e) { /* ignore */ }
  }

  function addToCart() {
    if (state.busy) return;
    var value = price();
    var variant = CONFIG.variants[state.flavor];
    var plan = state.sub ? CONFIG.sellingPlans[String(state.every)] : null;
    state.error = '';

    var product = ext.products && ext.products[state.flavor];
    var liveVariant = product && product.variants && product.variants.find(function (v) { return Number(v.id) === Number(variant); });
    if (!variant || !liveVariant || !liveVariant.available || liveVariant.price !== 2499 || CONFIG.currency !== 'USD' || (state.sub && !plan)) {
      state.error = 'This purchase option is currently unavailable. Please choose another flavor or try again later.';
      render();
      return;
    }

    var item = { id: Number(variant), quantity: state.bags };
    if (state.sub) item.selling_plan = Number(plan);

    state.busy = true;
    render();
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(base + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    })
      .then(function (res) {
        return res.json().then(function (body) {
          if (!res.ok) throw new Error(body && (body.description || body.message) || 'Could not add to cart.');
          return body;
        });
      })
      .then(function () {
        track(value);
        state.added = true;
        render();
        window.location.href = base + CONFIG.afterAdd;
      })
      .catch(function (e) {
        state.busy = false;
        state.error = (e && e.message ? e.message : 'Something went wrong.') + ' Please try again.';
        render();
        var card = q('[data-buy-form]');
        if (card && card.scrollIntoView) card.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      });
  }

  /* ---------- Video ---------- */
  var video = q('[data-reel]');
  var userPaused = false;
  var heardOnce = false;
  function safePlay() { try { var pr = video.play(); if (pr && pr.catch) pr.catch(function () {}); } catch (e) { /* ignore */ } }
  function renderVideo() {
    if (!video) return;
    var playing = !video.paused;
    var soundOn = !video.muted;
    var playBtn = q('[data-action="play"]');
    playBtn.setAttribute('aria-label', playing ? 'Pause video' : 'Play video');
    setHidden(playBtn.querySelector('[data-icon="pause"]'), !playing);
    setHidden(playBtn.querySelector('[data-icon="play"]'), playing);
    var soundBtn = q('[data-action="sound"]');
    soundBtn.setAttribute('aria-pressed', String(soundOn));
    setHidden(soundBtn.querySelector('[data-icon="muted"]'), soundOn);
    setHidden(soundBtn.querySelector('[data-icon="unmuted"]'), !soundOn);
    set('soundTxt', soundOn ? 'Sound on' : 'Tap for sound');
  }
  function toggleSound() {
    var turnOn = video.muted;
    video.muted = !turnOn;
    if (turnOn) {
      if (!heardOnce) { heardOnce = true; try { video.currentTime = 0; } catch (e) { /* ignore */ } }
      userPaused = false;
      safePlay();
    }
    renderVideo();
  }
  function togglePlay() {
    if (video.paused) { userPaused = false; safePlay(); }
    else { userPaused = true; video.pause(); }
  }
  if (video) {
    video.muted = true;
    ['play', 'pause', 'volumechange'].forEach(function (ev) { video.addEventListener(ev, renderVideo); });
  }

  /* ---------- Events ---------- */
  root.addEventListener('click', function (e) {
    var t = e.target.closest('[data-action],[data-flavor],[data-bags],[data-pace]');
    if (!t || !root.contains(t)) return;
    if (state.busy) return;
    var a = t.getAttribute('data-action');
    if (a === 'cta') { addToCart(); return; }
    if (a === 'sound') { toggleSound(); return; }
    if (a === 'play') { togglePlay(); return; }
    if (t.hasAttribute('data-flavor')) state.flavor = t.getAttribute('data-flavor');
    else if (t.hasAttribute('data-bags')) state.bags = Number(t.getAttribute('data-bags'));
    else if (t.hasAttribute('data-pace')) {
      var pace = t.getAttribute('data-pace').split('-');
      state.bags = Number(pace[0]);
      state.every = Number(pace[1]);
      state.sub = true;
    }
    state.added = false;
    state.error = '';
    render();
    // Lineup and pace picks send the shopper back to the buy box to confirm.
    if (t.hasAttribute('data-jump') || t.hasAttribute('data-pace')) scrollToBuy();
  });
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (state.busy) { render(); return; }
    if (t.name === 'bb-purchase') state.sub = t.value === 'sub';
    else if (t.hasAttribute('data-every')) { state.every = Number(t.value); state.sub = true; }
    else return;
    state.added = false;
    state.error = '';
    render();
  });

  // FAQ: one answer open at a time
  qa('.bb-faq__item').forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (!d.open) return;
      qa('.bb-faq__item').forEach(function (o) { if (o !== d) o.open = false; });
    });
  });

  /* ---------- Scroll behavior ---------- */
  if ('IntersectionObserver' in window) {
    // Hide the mobile buy bar while the main Add to cart button is on screen.
    var bar = q('[data-mbar]');
    var mainCta = q('.bb-cta');
    if (bar && mainCta) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { bar.classList.toggle('is-tucked', en.isIntersecting); });
      }, { threshold: 0.5 }).observe(mainCta);
    }
    // Play the reel (muted) only while it's on screen.
    if (video) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { if (!reduceMotion && !userPaused && video.paused) safePlay(); }
          else if (!video.paused) video.pause();
        });
      }, { threshold: 0.5 }).observe(video);
    }
  }

  render();
  renderVideo();
})();
